// extracted by mini-css-extract-plugin
export default {"kadoWidgetModal":"KadoWidgetModal_kadoWidgetModal__irC9m","title":"KadoWidgetModal_title__LUXTl"};